module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp3_8.6fbf44c3.png";